import { useEffect, useState } from "react";
import { MailOpen, Trash2 } from "lucide-react";
import { DashboardLayout } from "../../components/DashboardLayout";
import { EmptyState } from "../../components/Common";
import { ADMIN_MENU } from "../../lib/menus";
import { formatDate } from "../../lib/format";
import api from "../../lib/api";

export default function AdminMessages() {
  const [rows, setRows] = useState(null);

  const load = () => api.get("/admin/contact-messages").then((response) => setRows(response.data)).catch(() => setRows([]));

  useEffect(() => {
    document.title = "Pesan Masuk - DS KODE";
    load();
  }, []);

  const markRead = async (id) => {
    await api.put(`/admin/contact-messages/${id}/read`);
    setRows((current) => current.map((row) => row.id === id ? { ...row, is_read: true } : row));
  };

  const remove = async (id) => {
    if (!window.confirm("Hapus pesan ini?")) return;
    try {
      await api.delete(`/admin/contact-messages/${id}`);
      setRows((current) => current.filter((row) => row.id !== id));
    } catch (error) {
      window.alert(error?.response?.data?.detail || "Pesan gagal dihapus.");
    }
  };

  return (
    <DashboardLayout title="Pesan Masuk" menu={ADMIN_MENU} testid="admin-messages">
      {rows === null ? <div className="h-64 skeleton rounded-xl" /> : rows.length === 0 ? <EmptyState icon={MailOpen} title="Belum ada pesan masuk." /> : (
        <div className="space-y-4">
          {rows.map((row) => (
            <article key={row.id} className={`card p-5 ${row.is_read ? "" : "border-indigo-300"}`}>
              <div className="flex flex-wrap items-start justify-between gap-3">
                <div><h2 className="font-heading font-bold text-slate-900">{row.name}</h2><p className="text-sm text-indigo-600">{row.email}</p></div>
                <div className="flex items-center gap-3"><time className="text-xs text-slate-400">{formatDate(row.created_at)}</time>{!row.is_read && <button onClick={() => markRead(row.id)} className="btn-outline text-xs py-1.5">Tandai dibaca</button>}<button onClick={() => remove(row.id)} className="rounded-lg p-2 text-red-500 hover:bg-red-50" aria-label="Hapus pesan"><Trash2 className="h-4 w-4" /></button></div>
              </div>
              <p className="mt-4 whitespace-pre-line text-sm leading-relaxed text-slate-600">{row.message}</p>
            </article>
          ))}
        </div>
      )}
    </DashboardLayout>
  );
}